import { http } from '../util/http';

export default class AuthService {
	static login(email, password) {
		return http.post('/login', { email, password });
	}

	static signup(data) {
		return http.post('/signup', data);
	}

	static logout() {
		return http.get('/logout').catch(() => {});
	}
}
